import { FeatureFlags } from '@dupe/common/constants'
import { useEffect } from 'react'
import useIsFeatureOn from '~/src/hooks/useIsFeatureOn'
import { setCatalogCountryFilterHeader } from '~/src/lib/catalogCountryFilterHeader'

/**
 * Reads `catalog-country-filter` for this user and mirrors it into the header
 * `fetcher` sends to the API. Mounted once in `SearchProvider`; returns the
 * value for callers (BrainChat) that build their own headers.
 * `undefined` while the flag is loading: no header, the API uses its gate.
 */
export function useCatalogCountryFilter(): boolean | undefined {
  const { featureOn } = useIsFeatureOn(FeatureFlags.CatalogCountryFilter)
  const enabled = featureOn === undefined ? undefined : featureOn === true
  useEffect(() => {
    setCatalogCountryFilterHeader(enabled)
  }, [enabled])
  return enabled
}
